<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="首页" name="first" :lazy="true">
        <GlobalProfile></GlobalProfile>
      </el-tab-pane>
      <el-tab-pane label="慢性病画像" name="second" :lazy="true">
        <ChronicDiseaseView></ChronicDiseaseView>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ChronicDiseaseView from "@/views/profile/ChronicDiseaseView";
import GlobalProfile from "@/views/profile/GlobalProfile";

export default {
  name: "ProfileHome",
  components: {
    ChronicDiseaseView,
    GlobalProfile,
  },
  data() {
    return {
      activeName: "first",
    }
  },
}
</script>

<style scoped>

</style>
